export enum FrontendResponseCode {
  NotFound = 404
}
